"use strict";

//Exported value for process.env.baseUrl
//Always use values exported from this package instead of process.env.XXX directly
export default process.env.baseUrl;